import i18n from '../../utils/i18n'

export const VolumeUnitBodyTemplate = (unit?: string) => {
  if (!unit) return null

  return (
    <>
      {i18n.t(
        `masterDataManagement.packagingData.table.columns.volumeUnit.options.${unit}`,
      )}
    </>
  )
}
